import {
  CREATE_CUSTOM_TRAINING_ASYNC,
  FETCH_TRAINING_VIDEOS_ASYNC,
  LANGUAGE_FILTER_CHANGE,
  SEASON_FILTER_CHANGE,
  SET_IS_VISITED,
  SOURCE_FILTER_CHANGE,
  TYPE_FILTER_CHANGE,
  UPLOAD_VIDEO_LINK_ASYNC,
} from './constants'

const fetchTrainingVideos = (vendor) => ({
  type: FETCH_TRAINING_VIDEOS_ASYNC.INITIATE,
  payload: { vendor },
})
export const fetchTrainingVideosSuccess = (data) => ({
  type: FETCH_TRAINING_VIDEOS_ASYNC.SUCCESS,
  payload: { data },
})
const fetchTrainingVideosCancel = () => ({
  type: FETCH_TRAINING_VIDEOS_ASYNC.CANCEL,
})
export const fetchTrainingVideosError = (error) => ({
  type: FETCH_TRAINING_VIDEOS_ASYNC.ERROR,
  error,
})
const sourceFilterChange = (sourceFilter) => ({
  type: SOURCE_FILTER_CHANGE,
  payload: { sourceFilter },
})
const seasonFilterChange = (value) => ({
  type: SEASON_FILTER_CHANGE,
  payload: { value },
})
const languageFilterChange = (value) => ({
  type: LANGUAGE_FILTER_CHANGE,
  payload: { value },
})
const typeFilterChange = (value) => ({
  type: TYPE_FILTER_CHANGE,
  payload: { value },
})

const setIsVisited = (value) => ({
  type: SET_IS_VISITED,
  payload: { value },
})

const uploadVideoLink = (url, localeId, trainingId) => ({
  type: UPLOAD_VIDEO_LINK_ASYNC.INITIATE,
  payload: { url, localeId, trainingId },
})
export const uploadVideoLinkError = (error) => ({
  type: UPLOAD_VIDEO_LINK_ASYNC.ERROR,
  error,
})
export const uploadCustomVideoSuccess = (trainingVideo) => ({
  type: UPLOAD_VIDEO_LINK_ASYNC.SUCCESS,
  payload: { trainingVideo },
})

const createCustomTraining = () => ({
  type: CREATE_CUSTOM_TRAINING_ASYNC.INITIATE,
})
export const createCustomTrainingError = (error) => ({
  type: CREATE_CUSTOM_TRAINING_ASYNC.ERROR,
  error,
})
export const createCustomTrainingSuccess = (id) => ({
  type: CREATE_CUSTOM_TRAINING_ASYNC.SUCCESS,
  payload: { id },
})

export default {
  // to props
  fetchTrainingVideos,
  fetchTrainingVideosCancel,
  sourceFilterChange,
  uploadVideoLink,
  uploadCustomVideoSuccess,
  seasonFilterChange,
  setIsVisited,
  languageFilterChange,
  typeFilterChange,
  createCustomTraining,
}
